import { render, staticRenderFns } from "./DashboardChart.vue?vue&type=template&id=1cd1635d&scoped=true&"
import script from "./DashboardChart.vue?vue&type=script&lang=js&"
export * from "./DashboardChart.vue?vue&type=script&lang=js&"
import style0 from "./DashboardChart.vue?vue&type=style&index=0&id=1cd1635d&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cd1635d",
  null
  
)

export default component.exports